import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { motion } from 'framer-motion';
import { SearchX } from 'lucide-react';

export default function CompanyFundsError({ onRetry }: { onRetry: () => void }) {
  return (
    <Card className="mt-4">
      <CardContent className="p-6">
        <motion.div 
          className="flex flex-col items-center justify-center py-8 text-center"
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.3 }}
        >
          <motion.div
            initial={{ rotate: -10, opacity: 0 }}
            animate={{ rotate: 0, opacity: 1 }}
            transition={{ duration: 0.4 }}
          >
            <SearchX className="h-12 w-12 text-gray-400" />
          </motion.div>
          <motion.h3 
            className="mt-4 text-lg font-medium"
            initial={{ opacity: 0, y: 5 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.3 }}
          >
            Failed to load related funds
          </motion.h3>
          <motion.p 
            className="mb-4 text-sm text-muted-foreground"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.3 }}
          >
            There was an error loading the related funds. Please try again.
          </motion.p>
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.3 }}
          >
            <Button onClick={onRetry}>Retry</Button>
          </motion.div>
        </motion.div>
      </CardContent>
    </Card>
  );
}
